//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQSelectionCard from "@/components/Generics/AQSelectionCard/AQSelectionCard.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

export default {
    components: {
        AQButton,
        AQModal,
        AQInput,
        AQRadio,
        AQSelectionCard,
        AQCard,
        AQTooltip
    },
    props: {
        uuid: {
            required: true,
            type: String
        },
        elementIndex: {
            type: Number,
            default: 0
        },
        readonly: {
            type: Boolean
        },
        value: {
            type: String,
            default: ""
        },
        canBeDeleted: {
            type: Boolean,
            default: false
        },
        hideCreateNew: {
            type: Boolean,
            default: false
        },
        guiModalTitle: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            modalOpened: false,
            selectedGui: "",
            search: "",
            primary: {
                label: this.$t("generic.done"),
                disabled: true
            },
            hovered: false,
            missingInterface: false
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData", "guiForProcessDefinition", "diagramConfigData"]),
        ...mapGetters("apps", ["currentApp"]),
        assignedGuiName() {
            let uiName = "";
            if (this.value) {
                const current = this.guiForProcessDefinition.find(el => el.id === this.value);
                uiName = current ? current.name : this.$t("generic.notFound", { id: this.value });
            }
            let guiFound = false;
            // wip
            // eslint-disable-next-line consistent-return
            this.guiForProcessDefinition.forEach(el => {
                if (el.id === this.value) {
                    uiName = el.name;
                    guiFound = true;
                    return false;
                }
            });

            if (!guiFound) {
                uiName = this.$t("generic.notFound", { id: this.value });
            }

            return uiName;
        },
        computedValue: {
            get() {
                return this.selectedGui || this.value;
            },
            set(v) {
                this.selectedGui = v;
            }
        },
        setGuiModalTitle() {
            let title = "";
            if (this.guiModalTitle) {
                title = this.guiModalTitle;
            } else {
                title = `${this.selectedPluginConfigData.label} / ${this.$t("diagrams.components.setGui.addInterface")}`;
            }
            return title;
        },
        filteredList() {
            // wip
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.guiForProcessDefinition.sort((firstInterface, secondInterface) => firstInterface.name.localeCompare(secondInterface.name));
            return this.guiForProcessDefinition.filter(interf => {
                const fullInterfName = interf.code ? `${interf.name} (${interf.code})` : interf.name;
                return fullInterfName.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    watch: {
        computedValue() {
            this.primary.disabled = false;
        },
        value: {
            handler(val) {
                this.selectedGui = val;
            },
            immediate: true
        }
    },
    created() {
        this.$store.dispatch("diagrams/getGuiForProcessDefinition", true);
    },
    methods: {
        createNewInterface() {
            this.$router.push({ path: `/applications/${this.currentApp.id}/userInterfaces` });
            this.$root.$emit("buildNewInterface", true);
        },
        action(action) {
            if (action === "primary") {
                if (this.selectedGui) {
                    this.$emit("input", this.selectedGui);
                    this.hide();
                }
            } else if (action === "close") {
                this.selectedGui = this.value;
                this.hide();
            }
        },
        checkNumberUsages(noOfUsages) {
            let numberDescription = "";
            if (noOfUsages) {
                const checkCount = noOfUsages > 1 ? 2 : noOfUsages;
                numberDescription = this.$tc("diagrams.components.setGui.wasAssigned", checkCount, { count: noOfUsages });
            } else {
                numberDescription = this.$t("diagrams.components.setGui.wasNotAssigned");
            }
            return numberDescription;
        },
        selectInterface(interfaceId) {
            this.selectedGui = interfaceId;
        },
        deleteInterface() {
            this.hovered = false;
            this.$emit("deleteInterface");
        },
        openModal() {
            if (!this.readonly) {
                this.$store.dispatch("diagrams/getGuiForProcessDefinition", true);
                this.modalOpened = true;
            }
        },
        hide() {
            this.search = "";
            this.primary.disabled = true;
            this.modalOpened = false;
        }
    }
};
